
export enum UserAction {
    BUY_OTP = 'BUY_OTP',
    REMOTE_START = 'REMOTE_START',
    REMOTE_STOP = 'REMOTE_STOP',
    RESERVE = 'RESERVE',
}
